import { Component, Inject, computed, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import type { FrontendReleaseManifest } from '../../services/others/frontend-update.service';
import { WhatsappThemeService } from '../../services/others/whatsapp-theme.service';

export interface FrontendUpdateDialogData extends FrontendReleaseManifest {
  retryLimitReached: boolean;
}

@Component({
  selector: 'app-frontend-update-required',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, MatIconModule, MatPaginatorModule],
  templateUrl: './frontend-update-required.component.html',
  styleUrl: './frontend-update-required.component.scss',
})
export class FrontendUpdateRequiredComponent {
  readonly pageSize = 4;
  readonly pageIndex = signal(0);
  readonly totalPages = computed(() => Math.ceil((this.data.features?.length ?? 0) / this.pageSize));
  readonly currentPageIndex = computed(() => {
    const lastPageIndex = Math.max(this.totalPages() - 1, 0);
    return Math.min(this.pageIndex(), lastPageIndex);
  });
  readonly paginatedFeatures = computed(() => {
    const start = this.currentPageIndex() * this.pageSize;
    return (this.data.features ?? []).slice(start, start + this.pageSize);
  });
  readonly showPaginator = computed(() => this.totalPages() > 1);

  constructor(
    private dialogRef: MatDialogRef<FrontendUpdateRequiredComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FrontendUpdateDialogData,
    public whatsappThemeService: WhatsappThemeService,
  ) {
    this.dialogRef.disableClose = true;
  }

  actualizar(): void {
    this.dialogRef.close(true);
  }

  onPageChange(event: PageEvent): void {
    const lastPageIndex = Math.max(this.totalPages() - 1, 0);
    const nextPageIndex = Math.min(Math.max(event.pageIndex, 0), lastPageIndex);
    this.pageIndex.set(nextPageIndex);
  }
}
